module.exports = __webpack_public_path__ + "img/mom.14ffb6fd.gif";